import { render, staticRenderFns } from "./stockDetailDialog.vue?vue&type=template&id=3146f834&scoped=true&"
import script from "./stockDetailDialog.vue?vue&type=script&lang=js&"
export * from "./stockDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3146f834",
  null
  
)

export default component.exports